
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SmartColumn, SortState } from './smartTable.types';
import { MIN_COLUMN_WIDTH_PX } from './smartTable.types';
import { ReactComponent as NoResultsFoundSVG } from "itd-common/assets/images/svgs/no_results_found.svg";
import Button from '../../controls/buttons/button';
import {ReactComponent as DefaultImageSVG} from "itd-common/assets/icons/noResult.svg";

interface BodyGridProps {
  visibleColumns: SmartColumn[];
  pageData: any[];
  formatValue: (row: any, col: SmartColumn) => React.ReactNode;
  localStartIndex: number;
  sortState: SortState;
  onHeaderSort: (key: string) => void;
  clearFilters?: () => void;
  openRangeFilter?: () => void;
  hasSearched?: boolean;
}
const T_PREFIX: string = 'shared.smartTable.';
const SortIcon: React.FC<{ dir: 'asc' | 'desc' | undefined }> = ({ dir }) => (<span className="st-sort-icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path opacity="0.5" d="M6 9L10 5L14 9H6Z" fill="black" />
  <path opacity="0.5" d="M6 11L10 15L14 11H6Z" fill="black" />
</svg></span>);
const SmartTableBodyGrid: React.FC<BodyGridProps> = ({ visibleColumns, pageData, hasSearched, formatValue, localStartIndex, sortState, onHeaderSort, clearFilters, openRangeFilter }) => {
  const { t } = useTranslation();
  if (!hasSearched) {
    return (
      <div className="row">
        <div className="col-md-12 my-2 d-flex justify-content-center">
            <DefaultImageSVG />
        </div>
        <div className="col-md-12 mb-5 d-flex justify-content-center">
          <div
            style={{
              color: '#000',
              textAlign: 'center',
              fontSize: '15px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '19px'
            }}
          >
            Usá los filtros y encontrá lo que necesitás
          </div>
        </div>

      </div>
    );
  }

  return (
    
    <div className="st-table-container">
      {pageData && pageData.length > 0 ?
        <table className="st-table">
          <thead>
            <tr className="st-tr">
              {visibleColumns.map((col) => {
                const def = col.def;
                const isSortable = def.sortable === true;
                const current = sortState.key === col.key ? sortState.direction : undefined;
                return (
                  <th key={col.key} className={"st-th" + (def.type === 'number' ? ' st-th--number' : '') + (isSortable ? ' st-th--sortable' : '')} style={{ minWidth: MIN_COLUMN_WIDTH_PX }}>
                    <span className="d-flex" onClick={() => isSortable && onHeaderSort(col.key)}>{col.label}{isSortable && <SortIcon dir={current} />}</span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {pageData.length > 0 && (
              pageData.map((row, idx) => (
                <tr key={idx} className="st-tr">
                  {visibleColumns.map((col) => (
                    <td key={col.key} className={"st-td" + (col.def?.type === 'number' ? ' st-td--number' : '')}>
                      {formatValue(row, col)}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
        :
        <div className="row">
          <div className="col-md-12 my-2 d-flex justify-content-center">
            <NoResultsFoundSVG />
          </div>
          <div className="col-md-12 mb-5 d-flex justify-content-center">
            {openRangeFilter && <Button onClick={openRangeFilter} label={t(`${T_PREFIX}openRangeFilter`)} color='white' className="me-3"></Button>}
            {clearFilters && <Button onClick={clearFilters} label={t(`${T_PREFIX}clearFilters`)} color='primary'></Button>}
          </div>
        </div>
      }
    </div>
  );
};
export default SmartTableBodyGrid;
